import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrOvw202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_ovw_202605",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 97394,
  clicks: 1469,
  adsSpendDollars: 9789,
  budgetDollars: 15000,
  salesDollars: 46108,
  bestEstimateRoas: 4.71,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.65,
  newCustomersAcquired: 37,
  reorderConversions: 105,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
